<div class="card shadow-none">
    <div *ngIf="title.length > 0" class="d-flex align-content-center">
        <p class="shadow-none bg-white form-control-label">
            {{ title }}
            <ng-container *ngIf="tooltip.length > 0">
                <span class="badge badge-info ml-1" [ngbTooltip]="tooltip"
                    >?</span
                >
            </ng-container>
        </p>
    </div>
    <div class="html-container card-body">
        <div class="card-body">
            <div [innerHTML]="htmlContent"></div>
        </div>
    </div>
</div>
